import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    vendor: {
        firstName: "",
        lastName: "",
        age: "",
        gender: "male",
        email: "",
        phone: "",
        address: "",
        password: "",
        isDisable: false,
        commisionPercentage : 0,
        isActive : true,
        serviceCategoryId: '',
    },
    vendorList: [

    ]
}

const vendor = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default vendor;